import {useUser} from '@gaia/stores/user';

function isDayZeroUser(dateJoined: number | undefined) {
    if (!dateJoined) return false;
    const todayDate = new Date().getTime();
    const dayInMillis = 1000 * 60 * 60 * 24;
    return dateJoined > todayDate - dayInMillis;
}

export default function useIsDayZeroUser() {
    return isDayZeroUser(useUser().dateJoined);
}
